import { styled } from "@mui/material";

import { colors } from "@/Utils";

export const ColoredCircle = styled("div")<{ color: string }>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: ${colors.white};
  border: ${({ color }) => (color ? `3px solid ${color}` : "none")};
`;
